// FYI: Cant use SoftwareProduct from useSoftwareProducts here since that creates a circular dependency
import type { ApiSoftwareProduct } from 'common/api';

const sheduleEvents = [
  { id: 108, type: 'Change', icon: 'product/upgrade' },
  { id: 142, type: 'Cancel', icon: 'product/cancelled' },
  { id: 5245, type: 'Freeze', icon: 'product/frozen' },
  { id: 5252, type: 'Unfreeze', icon: 'product/unfreeze' },
  { id: 5229, type: 'Activation', icon: 'product/active' },
] as const;
const scheduleEventTypeMap = new Map(sheduleEvents.map((e) => [e.type, e]));

type EventTypes = (typeof sheduleEvents)[number]['type'];

export const getScheduleEventById = (id: number) => sheduleEvents.find((event) => event.id === id);

export const getScheduleOfType = (product: Pick<ApiSoftwareProduct, 'type' | 'schedules'>, type: EventTypes) => {
  if (product.type === 'Multiroom' || product.schedules.length === 0) return;
  const eventId = scheduleEventTypeMap.get(type)?.id;
  return eventId && product.schedules.find((s) => s.eventId === eventId);
};

const [V_Total, V_Premium] = ['Viaplay Total', 'V Premium'];
export const isViaplayStreamingProduct = (product: Pick<ApiSoftwareProduct, 'name'>) =>
  product.name === V_Total || product.name === V_Premium;
